import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import styled, { withTheme } from "styled-components";
import { ToastType } from "../../ToastManager/constants";
import { sendNotification } from "../../ToastManager/ToastManager";
import CustomChip from "../../ui-library/CustomChip/CustomChip";

import {
  favoriteMealsReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./FavoriteMeals.store";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const InfoLabel = styled.span`
  font-weight: 600;
  color: ${(props) => props.theme?.geminiGray};
`;

const GridContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 40px;
  margin-bottom: 35px;
`;

const GridItem = styled.div`
  cursor: pointer;
  width: 30%;
  margin: 5px;

  @media (max-width: 991px) {
    width: 45%;
  }

  @media (max-width: 375px) {
    width: 100%;
  }
`;

export const SmartFavoriteMeals = (props) => {
  const {
    fetchFavoriteMeals,
    favoriteMeals,
    onSelectFavoriteMeal,
    resetState,
  } = props;

  const { t } = useTranslation();

  useEffect(() => {
    fetchFavoriteMeals().catch((error) => {
      sendNotification(error, ToastType.ERROR);
    });
  }, [fetchFavoriteMeals]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  return (
    <Container data-testid="favorite-meals-grid">
      <InfoLabel>{t("appText.dietDiary.favoriteMeals.title")}</InfoLabel>

      <GridContainer>
        {favoriteMeals?.map((favorite) => (
          <GridItem key={favorite.favoriteId}>
            <CustomChip
              data-testid={`custom-chip-${favorite.favoriteId}`}
              text={favorite.name}
              backgroundColor={props.theme?.darkPurple}
              textColor={props.theme?.white}
              onClick={() => onSelectFavoriteMeal(favorite)}
            />
          </GridItem>
        ))}
      </GridContainer>
    </Container>
  );
};

export default dynamic(
  "favoriteMealsReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state, rootState) => {
      return {
        loginReducer: state.loginReducer,
      };
    },
  }),
  attachReducer(favoriteMealsReducer)
)(connect(mapStateToProps, mapDispatchToProps)(withTheme(SmartFavoriteMeals)));
